import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "l-protocol-list-page" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row justify-content-center" };
const _hoisted_4 = { class: "col-sm-8 col-md-6 col-lg-4 text-center" };
const _hoisted_5 = { class: "h4 text-white mb-4" };
const _hoisted_6 = { class: "small text-center mb-2" };
const _hoisted_7 = { class: "position-relative l-banner__select" };
const _hoisted_8 = { value: "product" };
const _hoisted_9 = { value: "protocol" };
const _hoisted_10 = { class: "flex-grow-1 l-banner__text" };
const _hoisted_11 = { class: "l-protocol-list-page__content" };
const _hoisted_12 = { class: "container" };
const _hoisted_13 = { class: "l-protocol-list-page__card" };
const _hoisted_14 = {
    key: 1,
    class: "l-content text-center"
};
import LandingContent from '@vue/components/front/protocol/LandingContent.vue';
import SearchContent from '@vue/components/front/protocol/SearchContent.vue';
import { toUpper } from 'lodash-es';
import { ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProtocolListApp',
    props: {
        type: {},
        q: {},
        page: {},
        order: {},
        dir: {}
    },
    setup(__props) {
        const props = __props;
        const type = ref(props.type);
        const q = ref(props.q);
        const page = ref(props.page);
        const order = ref(props.order);
        const dir = ref(props.dir);
        const loading = ref(false);
        watch(q, (value, oldValue) => {
            if ((oldValue === '' && value) || (oldValue && value === '')) {
                loading.value = true;
                window.setTimeout(() => {
                    loading.value = false;
                }, 1000);
            }
            if (oldValue === '' && value) {
                page.value = 1;
                order.value = 'lang.title';
                dir.value = 'ASC';
            }
            if (oldValue && value === '') {
                page.value = 1;
                order.value = 'protocol.ordering';
                dir.value = 'ASC';
            }
        });
        const isSearchInputFocus = ref('');
        const defaultImg = u.data('defaultBannerImage');
        const img = u.data('bannerImage');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "l-banner",
                    style: _normalizeStyle(`background-image: url(${_unref(img) ? _unref(img) : _unref(defaultImg)})`)
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(toUpper)(_ctx.$lang('datavideo.protocol.list.title'))), 1),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$lang('datavideo.protocol.list.text')), 1),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["input-group position-relative l-banner__search flex-nowrap", isSearchInputFocus.value])
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-select",
                                            name: "type",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((type).value = $event)),
                                            onFocus: _cache[1] || (_cache[1] = ($event) => (isSearchInputFocus.value = 'focus')),
                                            onBlur: _cache[2] || (_cache[2] = ($event) => (isSearchInputFocus.value = ''))
                                        }, [
                                            _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$lang('datavideo.protocol.list.type.product')), 1),
                                            _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$lang('datavideo.protocol.list.type.protocol')), 1)
                                        ], 544), [
                                            [_vModelSelect, type.value]
                                        ]),
                                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa-solid fa-caret-down text-secondary" }, null, -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((q).value = $event)),
                                            ref: "inputRef",
                                            type: "text",
                                            name: "q",
                                            class: "form-control l-banner__input",
                                            onFocus: _cache[4] || (_cache[4] = ($event) => (isSearchInputFocus.value = 'focus')),
                                            onBlur: _cache[5] || (_cache[5] = ($event) => (isSearchInputFocus.value = ''))
                                        }, null, 544), [
                                            [_vModelText, q.value]
                                        ])
                                    ]),
                                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fal fa-search l-banner__icon text-secondary" }, null, -1))
                                ], 2)
                            ])
                        ])
                    ])
                ], 4),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            (!loading.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (!q.value)
                                        ? (_openBlock(), _createBlock(LandingContent, {
                                            key: 0,
                                            page: page.value,
                                            order: order.value,
                                            dir: dir.value
                                        }, null, 8, ["page", "order", "dir"]))
                                        : _createCommentVNode("", true),
                                    (q.value)
                                        ? (_openBlock(), _createBlock(SearchContent, {
                                            key: 1,
                                            q: q.value,
                                            type: type.value,
                                            page: page.value,
                                            order: order.value,
                                            dir: dir.value
                                        }, null, 8, ["q", "type", "page", "order", "dir"]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[8] || (_cache[8] = [
                                    _createElementVNode("div", {
                                        class: "spinner-border text-light",
                                        role: "status"
                                    }, [
                                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                    ], -1)
                                ])))
                        ])
                    ])
                ])
            ]));
        };
    }
});
